// This barrel is imported by instrumentation-client.ts and must stay free of
// React deps.
export {
  addMonitoringAction,
  addMonitoringError,
  clearMonitoringUser,
  initMonitoring,
  setMonitoringTrackingConsent,
  setMonitoringUser,
  setMonitoringUserFromIdentifyPayload,
} from "./monitoring";
